











import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class SocialIcon extends Vue {
  @Prop({ type: String, required: true }) private title!: string;
  @Prop({ type: String, required: true }) private src!: string;
  @Prop({ type: String, required: true }) private link!: string;
  @Prop({ type: Number, required: false, default: 36 }) private size!: number;
  @Prop({ type: Number, required: false, default: 1 }) private opacity!: number;
}
